/**
 * Currency formatter — cents → localized display string. Lifted out of
 * pages/portal/SubscriptionPage because PricingPage (public) imported it
 * from there, which pulled the whole portal chunk into the pricing chunk's
 * static graph (and transitively into the entry chunk on landing). Living
 * in lib/ keeps money chunk-neutral — no page can drag portal in by needing
 * this helper.
 */
export function money(cents: number, currency = 'usd'): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency.toUpperCase(),
    maximumFractionDigits: cents % 100 === 0 ? 0 : 2,
  }).format(cents / 100);
}
